import request from '@/utils/http'
import { PFX, SRM, SRM_FILE } from '../../constant/constant.js'
const SRM_PUBLIC = '/api-srm-web/public/supplier'

// 管理端司机分页列表
export const getManageDrivers = params => {
    return request({
        url: `${SRM}/supplierDriverInfo/manageDrivers`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}
// 司机审批记录分页列表
export const supplierDriverApprovalRecords = params => {
    return request({
        url: `${SRM}/supplierDriverApprovalRecords`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

// 工作台司机分页列表
export const getWorkbenchDrivers = params => {
    return request({
        url: `${SRM}/supplierDriverInfo/workbenchDrivers`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

// 停用司机
export const disableDrivers = params => {
    return request({
        url: `${SRM}/supplierDriverInfo/batchDisableRelation`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

// 启用司机前置校验
export const checkDelegatePhone = data => {
    return request({
        url: `${SRM}/checkDelegatePhone`,
        method: 'post',
        data,
    })
}

// 启用司机
export const enableDrivers = params => {
    return request({
        url: `${SRM}/supplierDriverInfo/batchEnableRelation`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

// 发起委派函签署司机
export const pushSignAndEnable = data => {
    return request({
        url: `${SRM}/pushSignAndEnable`,
        method: 'post',
        data,
    })
}

// 删除司机
export const deleteDrivers = params => {
    return request({
        url: `${SRM}/supplierDriverInfo/batchDelete`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

// 拉黑司机
export const blackDrivers = params => {
    return request({
        url: `${SRM}/supplierDriverInfo/pullBack`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

// 查看附件
export const getAttachment = (url, relationId, params = {}) => {
    return request({
        url: `${SRM}` + url + relationId,
        method: 'get',
        params: params,
    })
}

// 查询单个司机
export const singleDriver = (relationId, params = {}) => {
    return request({
        url: `${SRM}/supplierDriverInfo/viewDriver/` + relationId,
        method: 'get',
        params: params,
    })
}

// 编辑司机（提交）
export const editDriver = params => {
    return request({
        url: `${SRM}/supplierDriverInfo/updateDriver`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

// 验证身份证和姓名
export const checkDriver = params => {
    return request({
        url: `${SRM}/supplierDriverInfo/checkDriverInfo`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

// 获取登陆用户的供应商编码
export const getLoginUser = (params = {}) => {
    return request({
        url: `${SRM}/supplierDriverInfo/currentLoginUser/supplierInfo`,
        method: 'get',
        params: params,
    })
}

// 新增/编辑司机
export const addDriver = params => {
    return request({
        url: `${SRM}/supplierDriverInfo/addDriver`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

// 司机导出
export const exportDriver = (params = {}) => {
    return request({
        url: `${SRM_FILE}/supplierDriverInfo/exportDriver`,
        method: 'post',
        data: params,
        responseType: 'arraybuffer',
        headers: { 'Content-Type': 'application/json' },
    })
}

// 查看拉黑详情
export const viewBlackDriver = (driverId, params = {}) => {
    return request({
        url: `${SRM}/supplierDriverInfo/viewBackInfo/` + driverId,
        method: 'get',
        params: params,
    })
}
// 司机拉黑MIP审批查看拉黑详情
export const viewBlackDriverMIPDetail = (formInstanceId, relationId, params = {}) => {
    return request({
        url: `${SRM}/supplierDriverInfo/pullBack/blackMipInfo/${formInstanceId}/${relationId}`,
        method: 'get',
        params: params,
    })
}

// 判断司机非拉黑状态下，是否在走MIP流程中
export const checkGoingBlackMip = (driverCode, params = {}) => {
    return request({
        url: `${SRM}/supplierDriverInfo/pullBack/checkApproval/${driverCode}`,
        method: 'get',
        params: params,
    })
}

// 附件下载 ===> 委派函模板下载
export const downloadAttachment = params => {
    return request({
        url: `${SRM_PUBLIC}/supplierInfo/downloadRegisterGuide`,
        method: 'post',
        data: params,
        responseType: 'arraybuffer',
        headers: { 'Content-Type': 'application/json' },
    })
}

// 获取法人身份证号码, 若法人和司机的身份证一致，委派不必填
export const getCorporateIdCard = (supplierCode, params = {}) => {
    return request({
        url: `${SRM}/supplierDriverInfo/manage/supplierInfo/` + supplierCode,
        method: 'get',
        params: params,
    })
}

// 撤回审批
export const revokeApprove = relationId => {
    return request({
        url: `${SRM}/supplierDriverApproval/returnEvent/${relationId}`,
        method: 'put',
    })
}

// 审批详情信息（弹窗）
export const getDriverApproveDetail = relationId => {
    return request({
        url: `${SRM}/supplierDriverApproval/getApprovalDetail/${relationId}`,
        method: 'get',
    })
}

// 图片示例
export const getExample = fileName => {
    return request({
        url: `${SRM}/imageExample/view/${fileName}`,
        method: 'get',
        responseType: 'arraybuffer',
    })
}

// 司机审批页面详情
export const getDriverApprovePage = id => {
    return request({
        url: `${SRM}/supplierDriverApproval/getApprovalFormData/${id}`,
        method: 'get',
    })
}

// 通过司机审批
export const passDriverApprove = params => {
    return request({
        url: `${SRM}/supplierDriverApproval/passApproval`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

// 驳回司机审批
export const refuseDriverApprove = params => {
    return request({
        url: `${SRM}/supplierDriverApproval/refuseApproval`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

// 判断当前司机是否有审批
export const existApprovalDetail = relationId => {
    return request({
        url: `${SRM}/supplierDriverApproval/existApprovalDetail/${relationId}`,
        method: 'get',
    })
}

// 查看委派函附件列表
export const getDelegateList = relationId => {
    return request({
        url: `${SRM}/driverDelegate/getDelegateList/${relationId}`,
        method: 'get',
    })
}

// 委派函删除
export const deleteDelegate = delegateNo => {
    return request({
        url: `${SRM}/supplierDriverInfo/deleteDelegate/${delegateNo}`,
        method: 'delete',
    })
}

// 委派函撤回
export const electronicSealConUndo = delegateNo => {
    return request({
        url: `${SRM}/supplierDriverInfo/electronicSealConUndo/${delegateNo}`,
        method: 'PUT',
    })
}

// 委派函推送
export const electronicSealCon = delegateNo => {
    return request({
        url: `${SRM}/supplierDriverInfo/electronicSealCon/${delegateNo}`,
        method: 'PUT',
    })
}

// 司机列表--推送委派函
export const pushDelegate = params => {
    return request({
        url: `${SRM}/supplierDriverInfo/pushDelegate`,
        method: 'post',
        data: params,
    })
}
// 判断是否需要委派函无纸化
export const wantDelegatePaperless = supplierCode => {
    return request({
        url: `${SRM}/supplierDriverInfo/wantDelegatePaperless/${supplierCode}`,
        method: 'get',
    })
}

// 根据身份证号查询司机信息
export const queryDriverInfo = params => {
    return request({
        url: `${SRM}/supplierDriverInfo/queryDriverInfo`,
        method: 'post',
        data: params,
    })
}

// 新增司机信息(新版)
export const addDriverApprovalRecord = params => {
    return request({
        url: `${SRM}/supplierDriverApprovalRecord/add`,
        method: 'post',
        data: params,
    })
}

// 编辑司机信息(新版)
export const editDriverApprovalRecord = params => {
    return request({
        url: `${SRM}/supplierDriverApprovalRecord/edit`,
        method: 'post',
        data: params,
    })
}

// 特权新增司机信息(新版)
export const addDriverPrivilege = params => {
    return request({
        url: `${SRM}/supplierDriverApprovalRecord/addPrivilege`,
        method: 'post',
        data: params,
    })
}

// 特权编辑司机信息(新版)
export const editDriverPrivilege = params => {
    return request({
        url: `${SRM}/supplierDriverApprovalRecord/editPrivilege`,
        method: 'post',
        data: params,
    })
}

export const checkWPH = data => {
    return request({
        url: `${SRM}/supplierDriverInfo/checkWPH?downUrl=${data}`,
        method: 'post',
        data: {},
    })
}

// 签署详情
export const getSign = data => {
    return request({
        url: `${SRM}/driverDelegate/listByContractNo`,
        method: 'get',
        params: data,
    })
}

// 重推
export const repushSign = data => {
    return request({
        url: `${SRM}/driverDelegate/rePushByContractNo`,
        method: 'get',
        params: data,
    })
}

// 控制线下委派函可见
export const checkSupplierIsWhite = data => {
    return request({
        url: `${SRM}/checkSupplierIsWhite`,
        method: 'get',
        params: data,
    })
}

// 新增时判断手机是否被占用
export const checkDriverIsExists = data => {
    return request({
        url: `${SRM}/checkDriverIsExists`,
        method: 'get',
        params: data,
    })
}

// 编辑时判断手机是否被占用
export const checkDriverIsExistsByEdit = data => {
    return request({
        url: `${SRM}/checkDriverIsExistsByEdit`,
        method: 'get',
        params: data,
    })
}

// 司机车辆获取审批人信息
export const supplierDriverCarApprovalInfo = fdId => {
    return request({
        url: `${SRM}/supplierDriverCarApprovalInfo/${fdId}`,
        method: 'get',
    })
}

// 在途联系人列表
export const getOnWayContacts = data => {
    return request({
        url: `${SRM}/onWayContactsInfoPage`,
        method: 'post',
        data,
    })
}

// 司机复核通过
export const reviewPass = data => {
    return request({
        url: `${SRM}/supplierDriverApprovalRecord/reviewPass`,
        method: 'post',
        data,
    })
}

// 司机复核不通过
export const reviewReject = data => {
    return request({
        url: `${SRM}/supplierDriverApprovalRecord/reviewReject`,
        method: 'post',
        data,
    })
}
